import WebApiService from "@/services/webapi.service.js";
import Articolo from "@/models/articolo.model.js";

const state = {
    articoli: [],
    articoliFornitore: []
}

const getters = {

    getArticoli: (state) => {
        return state.articoli;
    },

    getArticoliFornitore: (state) => {
        return state.articoliFornitore;
    }
}

const mutations = {

    setArticoli: (state, articoli) => {
        state.articoli = articoli;      
    },

    setArticoliFornitore: (state, articoliFornitore) => {
        state.articoliFornitore = articoliFornitore;      
    }
}

const actions = {

    getArticoli: ({commit}, data) => {                                                                                                              
        return WebApiService.get('articoli/GetArticoliRicambio', data.token).then(
        (data) => {              
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }
                else{                  
                    commit("setArticoli", data.Data.map(
                        o => { return Object.assign(new Articolo(), o) }
                    ));
                    return [true, ""];            
                }
            },
            error => {                      
                return [false, ""];
            }
        )
        .catch(
            error => {return [false, ""]}
        );
    },
    
    getArticoliFornitore: ({commit}, data) => {                                                                                                              
        return WebApiService.get('Articoli/GetArticoliRicambioContratto', data.token, data.glbAttivita).then(
        (data) => {              
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }
                else{                  
                    commit("setArticoli", data.Data.map(
                        o => { return Object.assign(new Articolo(), o) }
                    ));
                    return [true, ""];            
                }
            },
            error => {                      
                return [false, ""];
            }
        )
        .catch(
            error => {return [false, ""]}
        );
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}